import React from 'react'
import './blog-review-card.css'

const BlogReviewCard = (props) => {
    // const [img, setImg] = React.useState('')
    // React.useEffect(() => {
    //     for(let i = 0; i < props.blog.Sections.length; i++) {
    //         if(props.blog.Sections[i].type === 'image') {
    //             setImg(props.blog.Sections[i].content)
    //             break
    //         }
    //     }
    // },[])
    return(
        <div className="blog-review-card" style={{backgroundImage: `url(${props.blog.Preview.ArticleImage})`}} onClick={() => props.reviewTheBlog(props.blog)}>
            <h3>{props.blog.Preview.Title}</h3>
            <h4>By: {props.blog.Preview.Author}</h4>
        </div>
    )
}
export default BlogReviewCard